import { LOADING_APP } from "actions";
export const loadingReducer = (state = true, action) => {
  switch (action.type) {
    case LOADING_APP:
      return state;
    default:
      return state;
  }
};
